__turbopack_context__.v({
  "form": "vnfjna_form",
  "or": "vnfjna_or",
});
